// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"101":"7bbc3811","237":"f7f8d94b","549":"629234f9","968":"53f1882f"}[chunkId] + ".chunk.js";
};